module.exports = __webpack_public_path__ + "img/IMG_6558_P_L_Foamcore.9ff2543d.jpg";